import {createAsyncThunk} from '@reduxjs/toolkit'

import {FLEA_MARKET} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {NavigationResult, ThunkApi} from '../interfaces'

/**
 * 거래톡 채팅방
 */
const navigateToFleaMarketTalk = createAsyncThunk<NavigationResult, {channelId: string}, ThunkApi<unknown>>(
    'navigateTo/FleaMarketTalk',
    async ({channelId}) => {
        changeBrowserLocation({url: `${FLEA_MARKET}/ch/${channelId}`, type: 'PUSH'})

        return Promise.resolve()
    },
)

export default navigateToFleaMarketTalk
